export type ScheduleMethod =
    | 'lori_step'
    | 'lori_advanced'
    | 'auto_scheduler'
    | 'walk_scheduler'
    | 'bulk_assign'
    | 'duplicate_turn'

export type SchedulePhase = 'setup' | 'review'

export type WorkOrderCreationSource =
    | 'ASSIGN'
    | 'AUTO_SCHEDULER_WEB'
    | 'LORI_STEP_WEB'
    | 'LORI_ADVANCED_WEB'
    | 'LORI_ADVANCED_MOBILE'
    | 'BULK_ASSIGN_WEB'
    | 'TURN_TEMPLATE_WEB'
    | 'WALK_SCHEDULER_WEB'
    | 'SERVICE_REQUEST'
    | 'ACTION_ITEM'
    | 'ACTION_ITEM_SUGGESTION'
    | 'CHANGE_ORDER'
    | 'MOVE_OUT_RULE'
    | 'AUTOMATION'

export const SCHEDULE_METHOD_TO_CREATION_SOURCE: Record<
    ScheduleMethod,
    WorkOrderCreationSource
> = {
    auto_scheduler: 'AUTO_SCHEDULER_WEB',
    lori_step: 'LORI_STEP_WEB',
    lori_advanced: 'LORI_ADVANCED_WEB',
    bulk_assign: 'BULK_ASSIGN_WEB',
    duplicate_turn: 'TURN_TEMPLATE_WEB',
    walk_scheduler: 'WALK_SCHEDULER_WEB',
}

export function scheduleMethodToCreationSource(
    method: ScheduleMethod | null | undefined,
): WorkOrderCreationSource {
    if (!method) {
        return 'AUTO_SCHEDULER_WEB'
    }
    return SCHEDULE_METHOD_TO_CREATION_SOURCE[method]
}
